import React from 'react';
import { every, isEmpty } from 'lodash';
import { Checkbox, styled } from '@mui/material';

import { connect } from 'react-redux';
import {
  selectAllRecipeBuilderAttrs,
  deselectAllRecipeBuilderAttrs,
} from '../../actions/recipeBuilder';

const muiStyles = {
  checkbox: {
    root: {
      width: 24,
      fontSize: 20,
    },
  },
};

const StyledCheckbox = styled(Checkbox)(muiStyles.checkbox.root);

function SelectAllAttrsCheckbox({
  gridId,
  schema,

  // from redux
  selectedAttrs,
  selectAllRecipeBuilderAttrs,
  deselectAllRecipeBuilderAttrs,
}) {
  const isSelected =
    !isEmpty(schema) &&
    !isEmpty(selectedAttrs) &&
    every(schema, ({ __name }) => selectedAttrs?.[__name]);

  function onChange(event, isChecked) {
    if (isChecked) {
      selectAllRecipeBuilderAttrs(schema, gridId);
    } else {
      deselectAllRecipeBuilderAttrs(gridId);
    }
  }

  return (
    <StyledCheckbox
      className="select-all-attrs-checkbox"
      checked={isSelected}
      onChange={onChange}
    />
  );
}

const mapStateToProps = (state, ownProps) => {
  const { gridId } = ownProps;
  const {
    recipeBuilder: { selectedAttrs },
  } = state;

  return {
    selectedAttrs: selectedAttrs[gridId],
  };
};

export default connect(mapStateToProps, {
  selectAllRecipeBuilderAttrs,
  deselectAllRecipeBuilderAttrs,
})(SelectAllAttrsCheckbox);
